const iconPaths = {
  arrow: (
    <>
      <path d="M5 12h13" />
      <path d="m13 6 6 6-6 6" />
    </>
  ),
  back: (
    <>
      <path d="M19 12H5" />
      <path d="m11 18-6-6 6-6" />
    </>
  ),
  chevron: <path d="m6 9 6 6 6-6" />,
  check: <path d="m5 12 4 4L19 6" />,
  close: (
    <>
      <path d="m6 6 12 12" />
      <path d="m18 6-12 12" />
    </>
  ),
  menu: (
    <>
      <path d="M4 7h16" />
      <path d="M4 12h16" />
      <path d="M4 17h16" />
    </>
  ),
  spark: (
    <>
      <path d="m12 3-1.2 5.8L5 10l5.8 1.2L12 17l1.2-5.8L19 10l-5.8-1.2L12 3Z" />
      <path d="m19 16-.6 2.4L16 19l2.4.6L19 22l.6-2.4L22 19l-2.4-.6L19 16Z" />
    </>
  ),
  code: (
    <>
      <path d="m8 9-3 3 3 3" />
      <path d="m16 9 3 3-3 3" />
      <path d="m14 5-4 14" />
    </>
  ),
  building: (
    <>
      <path d="M4 21V5l8-3 8 3v16" />
      <path d="M2 21h20" />
      <path d="M8 8h1M15 8h1M8 12h1M15 12h1M8 16h1M15 16h1" />
    </>
  ),
  cart: (
    <>
      <path d="M3 4h2l2.2 11.1a2 2 0 0 0 2 1.6h7.5a2 2 0 0 0 1.9-1.4L20 8H6" />
      <circle cx="9" cy="20" r="1" />
      <circle cx="17" cy="20" r="1" />
    </>
  ),
  brain: (
    <>
      <path d="M9.5 4.2A3.2 3.2 0 0 0 4 6.7a3.4 3.4 0 0 0 .4 6.3A3.2 3.2 0 0 0 8 18.4a3.2 3.2 0 0 0 4 1.2 3.2 3.2 0 0 0 4-1.2 3.2 3.2 0 0 0 3.6-5.4 3.4 3.4 0 0 0 .4-6.3 3.2 3.2 0 0 0-5.5-2.5 3.2 3.2 0 0 0-5 0Z" />
      <path d="M12 4v16M8 8.5c1.7.3 2.7 1.2 3.2 2.5M16 8.5c-1.7.3-2.7 1.2-3.2 2.5M8 15c1.4-.2 2.7-.8 3.4-2M16 15c-1.4-.2-2.7-.8-3.4-2" />
    </>
  ),
  layers: (
    <>
      <path d="m12 3 9 5-9 5-9-5 9-5Z" />
      <path d="m3 12 9 5 9-5" />
      <path d="m3 16 9 5 9-5" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3 20 6v5c0 5-3.4 8.7-8 10-4.6-1.3-8-5-8-10V6l8-3Z" />
      <path d="m8.5 12 2.2 2.2 4.8-5" />
    </>
  ),
  chart: (
    <>
      <path d="M4 19V5" />
      <path d="M4 19h17" />
      <path d="m7 15 4-4 3 2 5-6" />
      <path d="M17 7h2v2" />
    </>
  ),
  users: (
    <>
      <path d="M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20" />
      <circle cx="10" cy="8" r="3" />
      <path d="M16 5.2a3 3 0 0 1 0 5.6M20 20v-1.5a3.5 3.5 0 0 0-2.5-3.4" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
    </>
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </>
  ),
  phone: (
    <>
      <path d="M6.5 3.5 9 3l2 5-2 1.5a13 13 0 0 0 3.5 3.5L14 11l5 2 .5 2.5a2 2 0 0 1-2.1 2.4A16.8 16.8 0 0 1 4.1 5.6 2 2 0 0 1 6.5 3.5Z" />
    </>
  ),
  pin: (
    <>
      <path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z" />
      <circle cx="12" cy="10" r="2.2" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  quote: (
    <>
      <path d="M7.5 17H5a2 2 0 0 1-2-2v-4a5 5 0 0 1 5-5h1v3H8a2 2 0 0 0-2 2v1h3v3.5A1.5 1.5 0 0 1 7.5 17ZM18.5 17H16a2 2 0 0 1-2-2v-4a5 5 0 0 1 5-5h1v3h-1a2 2 0 0 0-2 2v1h3v3.5a1.5 1.5 0 0 1-1.5 1.5Z" />
    </>
  ),
  leaf: (
    <>
      <path d="M20 4C10 4 4 8.5 4 15c0 2.8 2 5 5 5 6.5 0 11-6 11-16Z" />
      <path d="M4 20c2.2-4 5.4-6.7 10-8" />
    </>
  ),
  play: <path d="m9 6 9 6-9 6V6Z" />,
};

export default function Icon({ name = "spark", size = 20, strokeWidth = 1.8, className = "" }) {
  return (
    <svg
      aria-hidden="true"
      className={`icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
    >
      {iconPaths[name] || iconPaths.spark}
    </svg>
  );
}
